<template>
  <div class="login">
    <div class="w12 flex_end">
      <div class="dlbd">
        <div class="hy1">欢迎使用</div>
        <div class="hy2">律观网帐号登录</div>
        <div class="zh flex_start">
          <div class="iconcen">
            <img src="../../assets/user/accicon.png" />
          </div>
          <input type="text" v-model="form.account" placeholder="账号" />
        </div>
        <div class="mm flex_start mt20">
          <div class="iconcen">
            <img src="../../assets/user/pwdicon.png" />
          </div>
          <input :type="pwdtype" v-model="form.password" placeholder="密码" />
          <div class="iconcen" @click="pwdshow = !pwdshow">
            <img src="../../assets/user/pwd_yicon.png" v-if="!pwdshow" />
            <img src="../../assets/user/pwd_xicon.png" v-if="pwdshow" />
          </div>
        </div>
        <div class="loginbtn mt20" @click="login">登录</div>
        <div class="between mt20 notextselect">
          <div class="jzmm flex_start" @click="keepwd = !keepwd">
            <div class="jzmmicon center" :class="{ hideicon: !keepwd }">
              <img src="../../assets/user/jzmmicon.png" />
            </div>
            记住密码
          </div>
          <div class="flex_end">
            <div class="wjmm" @click="tofgtpwd">忘记密码</div>
            <div class="mfzc" @click="tologsin">免费注册 >></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encode, decode } from "../../utils/auth";
export default {
  data: () => ({
    pwdshow: false,
    keepwd: false,
    form: {
      account: null,
      password: null,
    },
  }),
  created() {
    this.$store.commit("user/modifylt", "hi，欢迎登录");
  },
  beforeMount() {
    let locform = JSON.parse(localStorage.getItem("saveinfo")); //获取保存密码
    let currentime = Date.now();
    if (locform) {
      if (currentime - locform.time > 7 * 24 * 60 * 60 * 1000) {
        localStorage.removeItem("saveinfo");
      } else {
        this.keepwd = locform.keepwd;
        this.form.account = locform.account;
        this.form.password = decode(locform.password);
        console.log(this.form);
      }
    }
  },
  computed: {
    pwdtype() {
      return this.pwdshow ? "text" : "password";
    },
  },
  methods: {
    login() {
      let saveinfo = {
        account: this.form.account,
        password: encode(this.form.password),
        keepwd: true,
        time: Date.now(),
        overduetime: 7,
      };
      if (this.keepwd) {
        //是否保存密码
        saveinfo = JSON.stringify(saveinfo);
        localStorage.setItem("saveinfo", saveinfo);
      } else {
        localStorage.removeItem("saveinfo");
      }

      this.$router.push({
        path: "/user",
      });
    },
    tologsin(){
      this.$router.push('/log/logsig')
    },
    tofgtpwd(){
      this.$router.push('/log/fgtpwd')
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  height: 710px;
  background: url("~assets/user/loginbg.png") no-repeat;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding-top: 135px;
  }
  .dlbd {
    padding: 50px 30px;
    width: 385px;
    padding-bottom: 30px;
    background: #ffffff;
    position: relative;
    box-shadow: 1px 1px 9px 0px rgba(0, 0, 0, 0.11);
    .iconcen {
      width: 44px;
      text-align: center;
    }
    .hy1 {
      font-size: 30px;
      color: #333333;
      line-height: 30px;
    }
    .hy2 {
      margin-top: 20px;
      font-size: 18px;
      color: #333333;
      line-height: 18px;
    }
    .zh {
      margin-top: 30px;
      width: 100%;
      border: 1px solid #dddddd;
      border-radius: 3px;
      height: 42px;
      img {
        width: 17px;
        height: 17px;
      }
      input {
        height: 100%;
        border: none;
        outline: none;
        flex: 1;
      }
    }
    .mm {
      height: 42px;
      border: 1px solid #dddddd;
      input {
        width: 250px;
        height: 100%;
        border: none;
        outline: none;
      }
    }
    .loginbtn {
      width: 100%;
      height: 42px;
      line-height: 42px;
      text-align: center;
      background: #6398ff;
      border-radius: 3px;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        color: #ffffff;
        background: #0057ff;
      }
    }
    .jzmm {
      font-size: 14px;
      color: #999999;
      .jzmmicon {
        margin-right: 5px;
        width: 15px;
        height: 15px;
        border: 1px solid #333333;
        &.hideicon {
          img {
            display: none;
          }
        }
      }
    }
    .mfzc {
      font-size: 14px;
      color: #0057ff;
      cursor: pointer;
    }

    .wjmm {
      font-size: 14px;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
</style>